/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WrappedGetMonetaTransferRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {WrappedGetMonetaTransferResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const wrappedGetMonetaTransfer = (request: WrappedGetMonetaTransferRequest, options?: CashRequestOptions) => post<WrappedGetMonetaTransferRequest, WrappedGetMonetaTransferResponse>("/2.0/cash/wrapped-get-moneta-transfer", request, {...options, rejectOnError: true })